export const STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'Washington DC',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const STATE_KEYS = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'Washington DC': 'DC',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
};

export const ORDER_TYPE = {
  BASIC: 1,
  STANDARD: 2,
  PREMIUM: 3,
  RA_ONLY: 4,
  KIT_ONLY: 5,
  EIN_ONLY: 7,
  ONLY_501C3: 10,
  RA_RENEWAL: 11,
  INTERNATIONAL: 12,
  NAME_CHANGE: 13,
  REGISTERED_AGENT_CHANGE: 14,
  AMENDMENT: 15,
  CERTIFICATE_OF_GOOD_STANDING: 16,
  DISSOLUTION: 17,
  FOREIGN_QUALIFICATION: 18,
  NAME_CHECK: 19,
  ANNUAL_REPORT: 20,
  LICENSE_RESEARCH: 21,
  TRADEMARK_NAME_SEARCH: 23,
  FORM_2553: 24,
  ASSUMED_BUSINESS_NAME: 25,
  EXPEDITED: 26,
  VIRTUAL_ADDRESS: 27,
  GHOST_ORDER: 30,
  STANDARD_KIT: 31,
  GOLD_KIT: 32,
  PLATINUM_KIT: 33,
  REINSTATEMENT: 68,
  SALES_TAX_REGISTRATION: 72,
  BOIR: 73,
  STATE_FILINGS_BUNDLE: 74,
};
const MEDICARE_TAX_RATE = 0.029;
const SS_TAX_RATE = 0.124;
const SS_TAX_RATE_LOWER_BRACKET = 94200;
const SS_TAX_BASE_VALUE = 11680.8;

export const calculateTax = (val) => {
  const medicareTax = val * MEDICARE_TAX_RATE;
  const ssTax =
    val < SS_TAX_RATE_LOWER_BRACKET ? val * SS_TAX_RATE : SS_TAX_BASE_VALUE;
  return medicareTax + ssTax;
};

export const getBestMatchingString = (key, array) => {
  function calculateIndexSum(word, key) {
    let indexSum = 0;
    const penalty = 1000;
    for (const char of key) {
      const index = word.indexOf(char);
      indexSum += index !== -1 ? index : penalty;
    }
    return indexSum;
  }
  return array.reduce((bestMatch, current) => {
    return calculateIndexSum(current, key) < calculateIndexSum(bestMatch, key)
      ? current
      : bestMatch;
  }, array[0]);
};

export const pricesToShowByFormGroup = {
  change_your_registered_agent_form: {
    priceName: 'raChangeIncfile',
    feeNames: {
      LLC: 'raChangeLLC',
      SCorporation: 'raChangeCorp',
      CCorporation: 'raChangeCorp',
      Nonprofit: 'raChangeNpc',
    },
  },
  form_your_annual_report_form: {
    priceName: 'annualReportIncfile',
    feeNames: {
      LLC: 'annualReportLLC',
      SCorporation: 'annualReportCorp',
      CCorporation: 'annualReportCorp',
      Nonprofit: 'annualReportNpc',
    },
  },
  amendment_form: {
    priceName: 'amendIncfile',
    feeNames: {
      LLC: 'amendLLC',
      SCorporation: 'amendCorp',
      CCorporation: 'amendCorp',
      Nonprofit: 'amendNpc',
    },
  },
  search_by_state_c_corp_form: {
    priceName: 'CCorporation',
    feeNames: {
      LLC: '',
      SCorporation: '',
      CCorporation: '',
      Nonprofit: '',
    },
  },
};
